import React from 'react';
import { siteConfig, navLinks } from '../data/mockData';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Brand Column */}
          <div>
            <a href="#" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_cenwi-dumpsters/artifacts/as0yrnig_ChatGPT%20Image%20Jan%2023%2C%202026%2C%2002_46_35%20PM.png" 
                alt="Dump Trailer Dude"
                className="h-20 w-auto"
              />
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              {siteConfig.tagline}. Providing convenient, damage-free dump trailer solutions for residential and commercial projects.
            </p>
            <p className="text-[#22C55E] font-semibold flex items-center mb-6">
              <MapPin className="w-5 h-5 mr-2" />
              Servicing Central Wisconsin
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="p-2 rounded-full bg-gray-800 hover:bg-[#22C55E] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-full bg-gray-800 hover:bg-[#22C55E] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-full bg-gray-800 hover:bg-[#22C55E] transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 rounded-full bg-gray-800 hover:bg-[#22C55E] transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-[#22C55E] transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${siteConfig.phone}`}
                  className="flex items-center text-gray-400 hover:text-[#22C55E] transition-colors"
                >
                  <Phone className="w-5 h-5 mr-3 text-[#22C55E]" />
                  <span>{siteConfig.phoneFormatted}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${siteConfig.email}`}
                  className="flex items-center text-gray-400 hover:text-[#22C55E] transition-colors"
                >
                  <Mail className="w-5 h-5 mr-3 text-[#22C55E]" />
                  <span>{siteConfig.email}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start text-gray-400">
                  <MapPin className="w-5 h-5 mr-3 text-[#22C55E] flex-shrink-0 mt-0.5" />
                  <span>{siteConfig.address}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Dump Trailer Dude. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-[#22C55E] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-[#22C55E] text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-[#22C55E] text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
